var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResetOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38076_109876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77778 9.91667V8.75H10.8889V9.91667H7.77778ZM8.94444 14V13.0278H7.77778V11.8611H8.94444V10.8889H10.1111V14H8.94444ZM10.8889 13.0278V11.8611H14V13.0278H10.8889ZM11.6667 10.8889V7.77778H12.8333V8.75H14V9.91667H12.8333V10.8889H11.6667ZM13.825 5.44444H12.2111C11.8741 4.3037 11.2324 3.37037 10.2861 2.64444C9.33982 1.91852 8.24444 1.55556 7 1.55556C5.48333 1.55556 4.19663 2.08393 3.13989 3.14067C2.08315 4.19741 1.55504 5.48385 1.55556 7C1.55556 7.93333 1.76633 8.78889 2.18789 9.56667C2.60944 10.3444 3.17644 10.9796 3.88889 11.4722V9.33333H5.44444V14H0.777778V12.4444H2.60556C1.80185 11.7963 1.16667 11.0024 0.7 10.0629C0.233333 9.12333 0 8.10237 0 7C0 6.02778 0.184852 5.11726 0.554556 4.26844C0.924259 3.41963 1.42307 2.68074 2.051 2.05178C2.67893 1.42281 3.41782 0.923741 4.26767 0.554556C5.11752 0.18537 6.0283 0.000518519 7 0C8.67222 0 10.1404 0.515407 11.4046 1.54622C12.6687 2.57704 13.4755 3.87644 13.825 5.44444Z",
    fill: "var(--secondary-7)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38076_109876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetOutlined);
export default __webpack_public_path__ + "static/media/resetOutlined.0821f1ebb9abfaad287f3ee24ea1ab37.svg";
export { ForwardRef as ReactComponent };